module.exports = __webpack_public_path__ + "img/subscription_child_banner.1c1494ac.svg";